export default __webpack_public_path__ + "static/media/contigocheco_arabia.83272a44.jpg";